import * as React from "react";
import { forwardRef } from "react";
const SvgEventCategoryActivity = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M12.656 30.2396a14.5072 14.5072 0 0 1-4.0236-1.5721M19.1456 1.7599a14.6065 14.6065 0 0 1 0 28.4797M3.8608 24.2632a14.538 14.538 0 0 1-1.9907-4.2053m-.37-6.4919a14.5616 14.5616 0 0 1 1.4602-4.34l.2742-.4948m4.4032-4.7713a14.5275 14.5275 0 0 1 5.0182-2.2m3.2449 7.3732C15 11 12.656 16.0003 12.656 16.0003h6.4897l-3.2449 6.8673",
	stroke: "currentColor",
	strokeWidth: 3,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgEventCategoryActivity);
export default ForwardRef;
